import { createSelector } from "@reduxjs/toolkit"

import { selectTeam } from "../slices/authSlice"
import { selectAvailableTokens } from "../slices/creditSlice"

export const selectIsFreemiumUser = createSelector(
  selectTeam,
  selectAvailableTokens,
  (team, availableTokens) => !team || team.subscriptionType === "Freemium" || availableTokens <= 0
);